<template>
  <div class="user-welfare">
    <div class="form-box">
      <div class="amount-show">
        <span class="word-shadow">{{ missionInfo.value }}V币
          <span class="word">{{ missionInfo.value }}V币</span>
        </span>
      </div>

      <!-- 表单区域 -->
      <div class="form-wrap">
        <van-form v-if="missionState === 2" ref="userForm" @submit="onSubmit">
          <van-field v-model="phone"
            name="phoneRegular"
            center
            type="tel"
            autocomplete="off"
            maxlength="11"
            placeholder="请输入您的微信手机号"
            :rules="[{ validator: validateTel }]"
          >
            <template #button>
              <van-button native-type="button"
                          size="mini"
                          @click="onWechatCode"
                          :disabled="!phone || isSend">{{ sendStr }}</van-button>
            </template>
          </van-field>
          <van-field v-model="code"
            name="code"
            type="number"
            autocomplete="off"
            maxlength="6"
            placeholder="请输入验证码"
          />
          <div class="submit-btn">
            <van-button round
                        native-type="submit"
                        :disabled="!phone || !code">
              立即领取</van-button>
          </div>
        </van-form>

        <!-- 活动结束 -->
        <div v-else class="activity-end-tip">
          <div class="word">活动已结束</div>
          <div class="wx-btn-wrap">
            <van-button round class="home-btn">进入商城</van-button>
            <wx-open-launch-weapp id="launch-btn"
                                  username="gh_f73b570e759d"
                                  path="pages/home/index">
              <script type="text/wxtag-template">
                <van-button>进入商城</van-button>
              </script>
            </wx-open-launch-weapp>
          </div>
        </div>
      </div>
    </div>

    <!-- 布局分割 -->
    <div class="division-box"></div>

    <div class="content-box">
      <!-- 商品展示 -->
      <div class="goods-box">
        <div class="goods-top top-box">V币礼品展示</div>
        <van-row gutter="12">
          <van-col span="12" v-for="goods in goodsList" :key="goods.id">
            <div class="goods-item">
              <img :src="goods.img">
              <p>{{ goods.name }}</p>
              <span><span class="price">{{ goods.price }}</span>&nbsp;V币</span>
              <s >{{ goods.scribingPrice }}</s>
            </div>
          </van-col>
        </van-row>
      </div>

      <!-- 说明 -->
      <div class="explain-box">
        <div class="explain-top top-box">V币说明</div>
        <div>
          <p class="title">福利享不停，更多礼品尽在V币中心</p>
          <p class="content" v-for="item in explainList" :key="item.id">{{ item.text }}</p>
        </div>
      </div>
    </div>

    <!-- 领取成功弹窗 -->
    <van-dialog v-model="successDialog" :show-confirm-button="false" class="success-dialog">
      <div class="dialog-close" @click="successDialog = false"></div>
      <div class="dialog-content">
        <p class="title">获得V币</p>
        <p class="number">{{ missionInfo.value }}</p>
        <p class="result">{{ dialogType === 1 ? 'V币已下发至您的账号' : '您还未完成商城注册' }}</p>
        <p class="remind">{{ dialogType === 1 ? '请前往商城查看' : '注册后V币将发放至您的账号' }}</p>
        <div class="wx-btn-wrap">
          <van-button round class="popup-btn">{{ dialogType === 1 ? '立即使用' : '去注册' }}</van-button>
          <wx-open-launch-weapp v-if="dialogType === 1"
                                id="launch-btn"
                                username="gh_f73b570e759d"
                                path="pages/integral/home/index">
            <script type="text/wxtag-template">
              <van-button>立即使用</van-button>
            </script>
          </wx-open-launch-weapp>
          <wx-open-launch-weapp v-if="dialogType === 4"
                                id="launch-btn"
                                username="gh_f73b570e759d"
                                path="pages/getPhone/index?scene=1167">
            <script type="text/wxtag-template">
              <van-button>去注册</van-button>
            </script>
          </wx-open-launch-weapp>
        </div>
      </div>
    </van-dialog>

    <!-- 领取失败提示弹窗 -->
    <van-dialog v-model="failDialog" :show-confirm-button="false" class="fail-dialog">
      <div class="dialog-close" @click="failDialog = false"></div>
      <div class="dialog-content">
        <p class="result">领取失败</p>
        <p class="remind">{{ dialogType === 2 ? '您匹配的商城账号已经和其他微信绑定，请联系客服' : '您已领取了新人福利，不能再次领取' }}</p>
        <van-button v-if="dialogType === 2" round color="linear-gradient(#FFAA86, #FF5C59)" @click="failDialog = false">我知道了</van-button>
        <div v-if="dialogType === 3" class="wx-btn-wrap">
          <van-button round class="popup-btn">前往兑换礼品</van-button>
          <wx-open-launch-weapp id="launch-btn"
                                username="gh_f73b570e759d"
                                path="pages/integral/home/index">
            <script type="text/wxtag-template">
              <van-button>前往兑换礼品</van-button>
            </script>
          </wx-open-launch-weapp>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getWechatCodeUrl, apiSendCode, checkPhoneCode, getWechatOpenId, apiJudgeWelfare, apiGetWelfare, getMissionById } from '@/api/newUserWelfare'
import { common } from '@/mixins/common'
import { mapGetters } from "vuex"
import wx from 'weixin-js-sdk'
import { getSendNum, setSendNum, getCoUnionId, setCoUnionId } from '@/utils/auth'

export default {
  name: 'newUserWelfare',
  mixins: [common],
  data() {
    return {
      missionInfo: {
        value: 100
      }, // 任务信息
      missionState: 2, // 任务状态
      phone: '', // 电话
      code: '', // 验证码
      phoneRegular: /^1[3|4|5|7|8][0-9]\d{8}$/,
      goodsList: [ // 礼品列表
        { id: 1, name: '日相月抽纸', price: 300, scribingPrice: '¥6.8', img: require('../../../public/images/newUserWelfare/tissue-img.png') },
        { id: 2, name: '蒸汽眼罩', price: 1100, scribingPrice: '¥14.9', img: require('../../../public/images/newUserWelfare/patch-img.png') },
        { id: 3, name: '立白青柠洗洁精', price: 1700, scribingPrice: '¥18.8', img: require('../../../public/images/newUserWelfare/detergent-img.png') },
        { id: 4, name: '金龙鱼玉米油', price: 2800, scribingPrice: '¥29.9', img: require('../../../public/images/newUserWelfare/corn-oil-img.png') },
        { id: 5, name: '便携式消毒湿巾', price: 3500, scribingPrice: '¥36.9', img: require('../../../public/images/newUserWelfare/toweled-img.png') },
        { id: 6, name: '迷你榨汁机', price: 4100, scribingPrice: '¥69', img: require('../../../public/images/newUserWelfare/juicer-img.png') }
      ],
      explainList: [ // 说明列表
        { id: 1, text: '1.领取后，V币将发放至您的商城账号' },
        { id: 2, text: '2.V币可用作商城的商品的抵扣、礼品兑换' },
        { id: 3, text: '3.V币可进行线上/线下商品购买、参与群内活动等方式获取' },
        { id: 4, text: '4.在法律法规允许的范围内，vivo云南有权对本次活动的格式条款作出解释' },
        { id: 5, text: '5.划线价格指商品的上市价格或该商品曾经展示过的销售价，仅供参考' }
      ],
      sendStr: '获取验证码',
      dialogType: 1, // 弹窗类型
      isSend: false, // 正在发送验证码
      successDialog: false, // 领取成功弹窗
      failDialog: false // 领取失败弹窗
    }
  },
  computed: {
    ...mapGetters(["welfarePhone", "sendNum"])
  },
  mounted() {
    this.getMission()
    this.wxConfig(1)
    this.phone = this.welfarePhone
    const code = this.getQueryValue('code')
    if (code) {
      this.onWechatCode()
    }
    this.initShare()
  },
  methods: {
    // 获取任务信息
    getMission () {
      getMissionById({id: 4}).then(res => {
        if (res.success) {
          this.missionState = res.data.status
          const list = res.data.rewardVoList
          this.missionInfo = list.filter(el => el.type === 1)[0]
        } else {
          this.$toast(res.msg)
        }
      }).catch(() => {
        this.$toast('网络错误！')
      })
    },
    // 验证手机号
    validateTel (val) {
      if (!val) {
        this.$toast('请输入您的微信手机号')
        return false
      } else {
        if (!/^1[3|4|5|7|8][0-9]\d{8}$/.test(val)) {
          this.$toast('请输入正确的手机号')
        }
        return /^1[3|4|5|7|8][0-9]\d{8}$/.test(val)
      }
    },
    // 初始化分享配置
    initShare () {
      const url = location.href
      wx.ready(function () {  //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
          title: 'vivo云南新人免费福利大放送', // 分享标题
          desc: '注册即可领取新人福利，各种精美礼品等你免费兑换！', // 分享描述
          link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'http://lctech.oss-cn-chengdu.aliyuncs.com/shop/user/20211108/1636337560000.png', // 分享图标
          success: function (res) {
            console.log(res)
          }
        })
      })
    },
    // 获取微信授权
    onWechatCode () {
      this.$refs.userForm.validate('phoneRegular').then(resp => {
        this.$store.commit("set_welfarePhone", this.phone)
        const code = this.getQueryValue('code') // 获取code
        if (!code) {
          const paramObj = {
            url: 'http://auth.ynlctech.com?moduleType=2', // 当前登录界面的路径
            buCode: "vivoyn" // 需要授权给的公众号标识
          }
          getWechatCodeUrl(paramObj).then(res => {
            window.location.href = res.data
          }).catch((err) => {
            this.$toast('授权失败！')
          })
        } else {
          if (!getCoUnionId()) {
            this.getUnionId(code).then(() => {
              this.judgeWelfare()
            })
          } else {
            this.judgeWelfare()
          }    
        }
      })
    },
    // 获取UnionId
    async getUnionId (authCode) {
      await getWechatOpenId({buCode: 'vivoyn', code: authCode}).then(res => {
        if (res.success) {
          // this.unionId = 'o5jP-sl6xiciD4Krw5KlOE8070ps'
          // this.unionId = res.data.userMessage.unionid
          setCoUnionId(res.data.userMessage.unionid)
        } else {
          this.$toast(res.msg)
        }
      }).catch(() => {
        this.$toast('网络错误！')
      })
    },
    // 判断手机号注册状态及领取状态
    judgeWelfare () {
      const params = {
        buId: 1,
        phone: this.phone,
        unionId: getCoUnionId()
      }
      apiJudgeWelfare(params).then(resp => {
        if (resp.success) {
          this.dialogType = resp.data
          if (resp.data === 3) {
            this.failDialog = true
          } else {
            this.sendCode()
          }
        } else {
          this.$toast(resp.msg)
        }
      }).catch(() => {
        this.$toast('网络错误！')
      })
    },
    // 发送验证码
    sendCode () {
      if (getSendNum() >= 4) {
        this.$toast('每天最多只能发送4次验证码！')
      } else {
        this.validateBtn()
        apiSendCode({ phone: this.phone, type: 1 }).then((res) => {
          if (res.success) {
            const num = getSendNum() | 0
            setSendNum(num + 1)
            this.$toast('发送成功！')
          } else {
            this.$toast(res.msg)
          }
        }).catch(() => {
          this.$toast('网络错误！')
        })
      }
    },
    // 验证-码发送倒计时
    validateBtn () {
      // 倒计时
      let time = 59
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer)
          this.sendStr = '获取验证码'
          this.isSend = false
        } else {
          this.sendStr = time + 'S后重新获取'
          this.isSend = true
          time--
        }
      }, 1000)
    },
    // 提交
    onSubmit () {
      // 检查验证码是否正确
      checkPhoneCode({phone: this.phone, code: this.code}).then((res) => {
        if (res.success) {
          if (this.dialogType === 1) {
            const params = {
              phone: this.phone,
              unionId: getCoUnionId(),
              buId: 1,
              point: this.missionInfo.value
            }
            // 获取福利
            apiGetWelfare(params).then(resp => {
              if (resp.success) {
                this.successDialog = true
              } else {
                this.$toast(res.msg)
              }
            }).catch(() => {
              this.$toast('网络错误！')
            })
          } else if (this.dialogType === 4) {
            this.successDialog = true
          } else {
            this.failDialog = true
          }
        } else {
          this.$toast(res.msg)
        }
      }).catch(() => {
        this.$toast('网络错误！')
      })
    },
    // 截取url指定参数
    getQueryValue (queryName) {
      let queryVal = ''
      const queryStr = location.href.split('?')[1]
      if (queryStr) {
        const queryList = queryStr.split('#')
        for (let i = 0; i < queryList.length; i++) {
          if (queryList[i].split('=')[0] === queryName) {
            queryVal = queryList[i].split('=')[1]
            break
          }
        }
      }
      return queryVal
    }
  },
  beforeDestroy() {
    this.$store.commit("set_welfarePhone", '')
  }
}
</script>

<style lang="scss" scoped>
.user-welfare {
  position: relative;
  .form-box {
    position: relative;
    z-index: 100;
    display: flex;
    align-items: flex-end;
    height: 542px;
    margin-bottom: 19px;
    padding: 0 16px;
    background-image: url('/images/newUserWelfare/bg1-img.png');
    background-size: 100% auto;
    background-repeat: no-repeat;
    .amount-show {
      width: 100%;
      position: absolute;
      top: 72px;
      left: 0;
      text-align: center;
      .word-shadow {
        position: relative;
        font-size: 65px;
        font-weight: 800;
        color: #EB3D2E;
      }
      .word {
        position: absolute;
        top: -10px;
        left: -4px;
        background: linear-gradient(56deg, #FFF5E9 0%, #FED7A1 26%, #FFEED7 56%, #FFDFAF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      // .word {
      //   position: relative;
      //   font-size: 65px;
      //   font-weight: 800;
      //   background: linear-gradient(56deg, #FFF5E9 0%, #FED7A1 26%, #FFEED7 56%, #FFDFAF 100%);
      //   -webkit-background-clip: text;
      //   -webkit-text-fill-color: transparent;
      // }
      // .word::before {
      //   content: attr(data-text);
      //   position: absolute;
      //   z-index: -1;
      //   text-shadow: 3px 3px 0 #EB3D2E;
      // }
    }
    .form-wrap {
      position: relative;
      width: 100%;
      padding: 16px;
      margin-bottom: 36px;
      border-radius: 16px;
      // border: 2px solid #FFF2ED;
      background-image: linear-gradient(#FFE1C7, #FFC1AC);

      // 活动结束提示
      .activity-end-tip {
        width: 234px;
        margin: auto;
        text-align: center;
        .word {
          font-size: 26px;
          font-weight: 600;
          color: #333333;
          margin: 44px 0;
          line-height: 30px;
        }
      }

      // 表单样式
      .van-field {
        height: 41px;
        border-radius: 4px;
        margin-bottom: 14px;
        color: #000000;
        font-size: 16px;
        font-weight: 550;
        .van-button {
          border: none;
          font-size: 16px;
          color: #F93C30;
        }
        .van-button::before {
          background-color: transparent;
        }
      }
      .submit-btn {
        text-align: center;
        margin-top: 20px;
        .van-button {
          width: 235px;
          color: #FFFFFF;
          font-size: 21px;
          font-weight: 600;
          background-color: transparent;
          border: none;
          background-image: url('/images/newUserWelfare/submit-bg.png');
          background-size: cover;
        }
        .van-button--disabled {
          opacity: 0.6;
        }
      }
    }
    // 表单区域边框
    .form-wrap::after {
      content: '';
      position: absolute;
      top: -2px;
      right: -2px;
      bottom: -2px;
      left: -2px;
      border-radius: 16px;
      background-image: linear-gradient(#FFF2ED, #FFF0E5);
      z-index: -1;
    }
  }
  .division-box {
    position: absolute;
    top: 508px;
    width: 100%;
    height: 54px;
    background-image: url('/images/newUserWelfare/division-img.png');
    background-size: 100% auto;
    background-repeat: no-repeat;
    z-index: 100;
  }
  .content-box {
    position: relative;
    z-index: 100;
    padding: 0 16px 42px;
    background-image: linear-gradient(#FFDFBF, #FBE3C6);

    // 商品展示
    .goods-box {
      position: relative;
      padding: 43px 12px 13px;
      // border: 2px solid #FFEEDA;
      border-radius: 16px;
      background-image: linear-gradient(#FFA68F, #FF9F7E);
      .goods-top {
        width: 129px;
        height: 25px;
        background-image: url('/images/newUserWelfare/goods-top-img.png');
      }
      .goods-item {
        background-color: #FFFFFF;
        margin-bottom: 12px;
        border-radius: 4px;
        padding: 8px;
        img {
          width: 138px;
          height: 117px;
        }
        p {
          margin-top: 12px;
          font-size: 14px;
          font-weight: 600;
          color: #333333;
          margin-bottom: 4px;
        }
        span {
          font-size: 12px;
          font-weight: 550;
          color: #F06654;
          .price {
            font-size: 18px;
          }
        }
        s {
          margin-left: 12px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
        }
      }
    }
    // 说明
    .explain-box {
      position: relative;
      margin-top: 16px;
      padding: 39px 12px 25px;
      // border: 2px solid #FFEEDA;
      border-radius: 16px;
      background-image: linear-gradient(#FFA68F, #FF9F7E);
      color: #FFFFFF;
      .explain-top {
        width: 105px;
        height: 25px;
        background-image: url('/images/newUserWelfare/explain-top-img.png');
      }
      .title {
        font-size: 14px;
        font-weight: 550;
        margin-bottom: 16px;
      }
      .content {
        font-size: 12px;
        font-weight: 400;
        line-height: 21px;
      }
    }
    // 商品展示区边框
    .goods-box::after,
    .explain-box::after {
      content: '';
      position: absolute;
      top: -2px;
      right: -2px;
      bottom: -2px;
      left: -2px;
      border-radius: 16px;
      background-image: linear-gradient(#FFEEDA, #FFDEC5);
      z-index: -1;
    }
    .top-box {
      position: absolute;
      top: -7px;
      left: 50%;
      transform: translate(-50%, 0);
      background-size: 100% auto;
      background-repeat: no-repeat;
      font-size: 14px;
      font-weight: 550;
      color: #FFFFFF;
      text-align: center;
    }
  }
}
.success-dialog {
  width: 268px;
  height: 431px;
  background-image: url('/images/newUserWelfare/success-dialog-img.png');
  .dialog-close {
    position: absolute;
    top: 130px;
    right: -12px;
  }
  .dialog-content {
    .title {
      font-size: 16px;
      font-weight: 400;
      color: #E34E27;
      line-height: 21px;
      margin-bottom: 13px;
    }
    .number {
      font-size: 65px;
      font-weight: 600;
      color: #AE0400;
      line-height: 50px;
      margin-bottom: 20px;
    }
    .result {
      margin-bottom: 5px;
    }
    .remind {
      font-size: 14px;
      font-weight: 550;
      color: #AE0400;
      line-height: 16px;
      margin-bottom: 25px;
    }
  }
}
.fail-dialog {
  width: 268px;
  height: 313px;
  background-image: url('/images/newUserWelfare/fail-dialog-img.png');
  .dialog-close {
    position: absolute;
    top: 12px;
    right: -12px;
  }
  .dialog-content {
    .result {
      margin-bottom: 10px;
    }
    .remind {
      width: 230px;
      font-size: 16px;
      font-weight: 550;
      color: #AE0400;
      line-height: 25px;
      margin-bottom: 55px;
    }
  }
}
.van-dialog {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background-color: transparent;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: visible;
  .dialog-content {
    text-align: center;
    margin-bottom: 23px;
    .result {
      font-size: 20px;
      font-weight: 550;
      color: #AE0400;
      line-height: 28px;
    }
  }
  .dialog-close {
    width: 32px;
    height: 32px;
    background-image: url('/images/newUserWelfare/close-dialog-img.png');
    background-size: 100% 100%;
  }
}
.wx-btn-wrap {
  width: 234px;
  height: 42px;
  position: relative;
  .van-button {
    width: 234px;
    height: 42px;
    font-size: 21px;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 42px;
  }
  .home-btn {
    background-color: transparent;
    border: none;
    background-image: url('/images/newUserWelfare/submit-bg.png');
    background-size: cover;
  }
  .popup-btn {
    background: url('/images/newUserWelfare/btn-bg.png') center center no-repeat;
  }
  #launch-btn {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
